import React from 'react'
import Loading from '@modules/core/components/Loading'
import { isMobileOnly } from 'react-device-detect'
import { ReactSVG } from 'react-svg'
import close from '@resources/assets/img/close.svg'
import './style.scss'

const SimpleModal = ({ title, template, hideModal, loading, footer = null, hideClose, className }) => {
  return (
    <div className={`simple-modal ${isMobileOnly && 'mobile'} ${className}`}>
      <div className="sm-content">
        <div className="sm-header">
          {!hideClose && <ReactSVG className="close-button" src={close} onClick={hideModal} />}
          {title}
        </div>
        <div className="sm-body">
          <Loading isFetching={loading} />
          {template}
        </div>
        {footer && <div className="sm-footer">{footer}</div>}
      </div>
      <div className="shadow" onClick={hideModal} />
    </div>
  )
}

export default SimpleModal
